// extracted by mini-css-extract-plugin
export default {"salesmanager":"styles_salesmanager__k8pmQ","leftbutton":"styles_leftbutton__4TOn7","rightbutton":"styles_rightbutton__LwSyb"};